module.exports = __webpack_public_path__ + "static/custom-events2-f0fccf3f4ddb6eb23f3e19e9c81a2c74.png";